<!-- www.quickepay / Blog
Edited with WebStorm
Created by maizerg on 2/19/18 at 3:21 PM
<!-->

<template>
    <div id="blog">
        <quick-site-bread-crumb title="Últimas Novidades"/>

        <div class="blogArea secPdng">
            <div class="container">
                <article class="row">
                    <div class="col-md-4 col-sm-6">
                        <div class="singlePost">
                            <div class="postImg"><a href="#"><img src="../../assets/images/blog1.jpg" alt=""></a></div>
                            <div class="postContent">
                                <a href="#" class="postTitle h4">A digitalização da moeda</a>
                                <div class="postDate">24/Junho/2018</div>
                                <div class="postExcerpt">
                                    <p>A moeda tem sido tornado cada vez mais digital, resultado disso é uma maior
                                    procura de integração...</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4 col-sm-6 animated">
                        <div class="singlePost">
                            <div class="postImg"><a href="#"><img src="../../assets/images/blog2.jpg" alt=""></a></div>
                            <div class="postContent">
                                <a href="#" class="postTitle h4">Como integrar a moeda num mundo totalmente conectado?</a>
                                <div class="postDate">10/Junho/2018</div>
                                <div class="postExcerpt">
                                    <p>Num mundo que a cada dia vem se tornando conectado um dos principais desafios...</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4 col-sm-6  animated">
                        <div class="singlePost">
                            <div class="postImg"><a href="#"><img src="../../assets/images/blog3.jpg" alt=""></a></div>
                            <div class="postContent">
                                <a href="#" class="postTitle h4">"Inclusão financeira" como palavra de ordem</a>
                                <div class="postDate">12/Junho/2018</div>
                                <div class="postExcerpt">
                                    <p>A integracão de serviços as zonas rurais como uma meta...</p>
                                </div>
                            </div>
                        </div>
                    </div>
<!--
                    <div class="col-md-4 col-sm-6  animated">
                        <div class="singlePost">
                            <div class="postImg"><a href="#"><img src="../../assets/images/blog1.jpg" alt=""></a></div>
                            <div class="postContent">
                                <a href="#" class="postTitle h4">Best hosting services of 2016</a>
                                <div class="postDate">24th June, 2016</div>
                                <div class="postExcerpt">
                                    <p>Duis autem vel eum iriure dolor in hendrerit in <br> vulputate velit esse
                                        molestie consequat, vel illum <br>dolore eu feugiat nulla facilisis at vero
                                        eros...</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4 col-sm-6  animated">
                        <div class="singlePost">
                            <div class="postImg"><a href="#"><img src="../../assets/images/blog1.jpg" alt=""></a></div>
                            <div class="postContent">
                                <a href="#" class="postTitle h4">Best hosting services of 2016</a>
                                <div class="postDate">24th June, 2016</div>
                                <div class="postExcerpt">
                                    <p>Duis autem vel eum iriure dolor in hendrerit in <br> vulputate velit esse
                                        molestie consequat, vel illum <br>dolore eu feugiat nulla facilisis at vero
                                        eros...</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4 col-sm-6  animated">
                        <div class="singlePost">
                            <div class="postImg"><a href="#"><img src="../../assets/images/blog1.jpg" alt=""></a></div>
                            <div class="postContent">
                                <a href="#" class="postTitle h4">Best hosting services of 2016</a>
                                <div class="postDate">24th June, 2016</div>
                                <div class="postExcerpt">
                                    <p>Duis autem vel eum iriure dolor in hendrerit in <br> vulputate velit esse
                                        molestie consequat, vel illum <br>dolore eu feugiat nulla facilisis at vero
                                        eros...</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4 col-sm-6  animated">
                        <div class="singlePost">
                            <div class="postImg"><a href="#"><img src="../../assets/images/blog1.jpg" alt=""></a></div>
                            <div class="postContent">
                                <a href="#" class="postTitle h4">Best hosting services of 2016</a>
                                <div class="postDate">24th June, 2016</div>
                                <div class="postExcerpt">
                                    <p>Duis autem vel eum iriure dolor in hendrerit in <br> vulputate velit esse
                                        molestie consequat, vel illum <br>dolore eu feugiat nulla facilisis at vero
                                        eros...</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4 col-sm-6  animated">
                        <div class="singlePost">
                            <div class="postImg"><a href="#"><img src="../../assets/images/blog1.jpg" alt=""></a></div>
                            <div class="postContent">
                                <a href="#" class="postTitle h4">Best hosting services of 2016</a>
                                <div class="postDate">24th June, 2016</div>
                                <div class="postExcerpt">
                                    <p>Duis autem vel eum iriure dolor in hendrerit in <br> vulputate velit esse
                                        molestie consequat, vel illum <br>dolore eu feugiat nulla facilisis at vero
                                        eros...</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4 col-sm-6  animated">
                        <div class="singlePost">
                            <div class="postImg"><a href="#"><img src="../../assets/images/blog1.jpg" alt=""></a></div>
                            <div class="postContent">
                                <a href="#" class="postTitle h4">Best hosting services of 2016</a>
                                <div class="postDate">24th June, 2016</div>
                                <div class="postExcerpt">
                                    <p>Duis autem vel eum iriure dolor in hendrerit in <br> vulputate velit esse
                                        molestie consequat, vel illum <br>dolore eu feugiat nulla facilisis at vero
                                        eros...</p>
                                </div>
                            </div>
                        </div>
                    </div>-->
                </article>
                <div class="row">
                    <div class="col-md-12">
                        <div class="pagination  animated">
                            <ul>
                                <li><a href="#">Ante...</a></li>
                                <li><a href="#">1</a></li>
                                <li class="active"><a href="#">2</a></li>
                                <li><a href="#">3</a></li>
                                <li><a href="#">Prox...</a></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import QuickSiteBreadCrumb from '../../components/site/SiteBreadCrumb'
import Animate from '../../assets/js/animation'

export default {
  components: {QuickSiteBreadCrumb},
  mounted () {
    Animate()
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/blog/Blog.vue